import { useSelector } from '@redux';
import RestEdit from 'containers/rest/Edit';
import { DynamicObjectType } from 'types/commons';
import FormView from '../components/Form/View';
import { useMemo } from 'react';

const API_OPTIONS = {
  extraParams: {
    join: [
      'payments',
      'customer',
      'payment-method',
      'shippingCarrier',
      'creator',
      'returnWarehouse',
      'order.location',
    ],
  },
  isRequestApi: true,
};

const Show = () => {
  const data = useSelector<DynamicObjectType>(
    (state) => state.orders.currentData,
  );

  const breadcrumbs = useMemo(() => {
    return [
      {
        title: 'common.page.orders',
        href: '/order-management',
      },
      {
        title: `#${data?.id}`,
      },
    ];
  }, [data?.id]);

  return (
    <RestEdit
      model="ordersReturn"
      breadcrumbs={breadcrumbs}
      customUrlBack="/products/settings/categories"
      apiOptions={API_OPTIONS}
      hiddenLayoutTop
    >
      <FormView />
    </RestEdit>
  );
};

export default Show;
